export const USER = 'user-data';
export const AUTHTOKEN = 'user-token';
export const AUTHKey = 'auth-key';
export const ISACTIVESTRIPEUSER = 'stripe-user-v1'
export const S3_BASE_URL = "https://dflzczhyxe8dk.cloudfront.net/"
export const ISACTIVE = "isActive"
export const isSubscribed = "isSubscribed"
export const SUDANI_BASE_URL = "https://sudani.nasna.tv"
export const ZAIN_BASE_URL = "https://zain.nasna.tv"
export const USERLOGINID = "user-login-id"// the id could be phone number|email
export const AF = "AntiFrauduniqid"; // Anti-Fraud Uniq ID
export const SudaniOptions = [
  // {
  //   price: 295,
  //   period: "day",
  //   title: "الباقة اليومية",
  //   operators: ["mtn", "sudani", "zain"],
  //   popular: false,
  //   type: "internal",
  //   redirectUrl: "auth.operators.daily",
  // },
  
  {
    price: 2800,
    period: "weekly",
    title: "الباقة الأسبوعية",
    operators: [ "bravo"],
    popular: false,
    type: "internal",
    redirectUrl: "auth.operators.weekly",
  },
  {
    price: 4950,
    period: "month",
    title: "الباقة الشهرية",
    operators: ["bravo"],
    popular: true,
    type: "internal",
    redirectUrl: "auth.operators.monthly",
  },
  {
    price: 49599,
    discount:50,
    period: "year",
    title: "الباقة السنوية",
    operators: ["bravo"],
    popular: false,
    type: "internal",
    redirectUrl: "bravo.pay",
  },
];


export const SaudiOptions = [

  {
    price: 5.75,
    period: "weekly",
    title: "الباقة الأسبوعية",
    operators: ["mobily", "stc"],
    popular: false,
    type: "internal",
    redirectUrl: "auth.operators.weekly",
  },
  {
    price: 17.25,
    period: "month",
    title: "الباقة الشهرية",
    operators: ["mobily", "stc",'stripe'],
    popular: false,    type: "internal",
    redirectUrl: "auth.operators.monthly",
  },
   {
    price: 90,
    discount:45,
    period: "year",
    title: "الباقة السنوية",
    operators: [ 'stripe','bravo'],
    popular: false,
    type: "internal",
    redirectUrl: "auth.operators.yearly",
  },
];


export const UaeOptions = [
  {
    price: 2,
    period: "day",
    title: "الباقة اليومية",
    operators: ["etisalat","du"],
    popular: false,
    type: "external",
    redirectUrl: "https://ae.nasna.tv/subscribe",
  },
  {
    price: 7,
    period: "weekly",
    title: "الباقة الأسبوعية",
    operators: ["etisalat","du"],
    popular: false,
    type: "external",
    redirectUrl: "https://ae.nasna.tv/subscribe",
  },
  {
    price: 15,
    period: "month",
    title: "الباقة الشهرية",
    operators: ["etisalat","du",'stripe'],
    popular: false,
    type: "external",
    redirectUrl: "https://ae.nasna.tv/subscribe",
  },
   {
    price: 90,
    discount:45,
    period: "year",
    title: "الباقة السنوية",
    operators: [ 'stripe'],
    popular: false,
    type: "internal",
    redirectUrl: "auth.operators.yearly",
  },
];

export const egyptOptions = [

  {
    price: 19,
    period: "weekly",
    title: "الباقة الأسبوعية",
    operators: ["fawry"],//,'fawry'
    popular: false,
    type: "internal",
    redirectUrl: "auth.operators.weekly",
  },
  {
    price: 80,
    period: "month",
    title: "الباقة الشهرية",
    operators: [ 'stripe',"fawry"],
    popular: false,
    type: "internal",
    redirectUrl: "auth.operators.monthly",
  },
  {
    price: "480",
    discount:50,
    period: "year",
    title: "الباقة السنوية",
    operators: [ 'stripe',"fawry"],
    popular: false,
    type: "internal",
    redirectUrl: "auth.operators.yearly",
  },
];


export const restOfWorldOptions = [
 
  // {// adds
  //   price: 2.99,
  //   period: "month",
  //   title: "   الباقة الشهرية بإعلانات" ,
  //   operators: [ 'stripe'],
  //   popular: false,
  //   type: "internal",
  //   redirectUrl: "auth.operators.monthly",
  // },
  {
    price: 5.99,
    period: "month",
    title: "الباقة الشهرية",
    operators: [ 'stripe'],
    popular: false,
    type: "internal",
    redirectUrl: "auth.operators.monthly",
  },
   {
    price: 44.99,
    discount: 50,
    period: "year",
    title: "الباقة السنوية",
    operators: [ 'stripe'],
    popular: false,
    type: "internal",
    redirectUrl: "auth.operators.yearly",
  },
];


export const paymentGateways = {
  "السودان": [
    "سوداني",
    "زين",
    "أم تي إن",
    "برافو"
  ],
  "مصر": [
    "Stripe",
    "فوري"
  ],
  "السعودية": [
    "موبايلي",
    "STC",
    "Stripe"
  ],
  "الإمارات": [
    "إتصالات",
    "Du",
    "Stripe"
  ],
  "باقي دول العالم": [
    "Stripe"
  ]
};
// Country Plans Configuration
export const COUNTRY_PLANS = {
  "السودان": SudaniOptions,
  "مصر": egyptOptions,
  "السعودية": SaudiOptions,
  "الإمارات": UaeOptions,
  "باقي دول العالم": restOfWorldOptions
};

// Currency Configuration
export const COUNTRY_CURRENCIES = {
  "السودان": "جنيه",
  "مصر": "جنيه",
  "السعودية": "ريال",
  "الإمارات": "درهم",
  "باقي دول العالم": "دولار"
};



// Operator Logos
export const OPERATOR_LOGOS = {
  sudani: require("@/assets/tele/sudani-new.png"),
  mtn: require("@/assets/tele/mtn-logo.png"),
  zain: require("@/assets/tele/zain.png"),
  bravo: require("@/assets/tele/bravo.png"),
  mobily: require("@/assets/tele/mobily.png"),
  stc: require("@/assets/tele/stc.webp"),
  etisalat: require("@/assets/tele/etisalat.webp"),
  du: require("@/assets/tele/du.png"),
  stripe: [
     require("@/assets/payments/master-card.png"),
   require("@/assets/payments/Visa.png"),

  ], // Use generic icon for stripe
  fawry: require("@/assets/payments/fawry-1.png"),
};

// Period Labels
export const PERIOD_LABELS = {
  day: "اليوم",
  weekly: "الأسبوع",
  month: "الشهر",
  year: "السنة"
};
// Landing Page URLs for all possible subscriptions options

export const landingPageCountries = {
  sudan: {
    day: {
      sudani: "https://sudanipay.com/subscription/nasna/nasna",
      zain: "https://dsplp.sd.zain.com/af-lp/?p=7789312591",
      mtn: "https://cgmtnsd.digitalsp.net/632/OrMW",
    },
    weekly: {
     sudani: "https://sudanipay.com/subscription/nasna/NasnaTVWeekly",
      bravo: "bravo.pay",
    },
    month: {
       sudani: "https://sudanipay.com/subscription/nasna/NasnaTVMonthly",
        bravo: "bravo.pay",
    },
    year: {
     bravo: "bravo.pay",
    }
  },
  egypt: {
     weekly: {
      
      stripe: "auth.subscriptions",
      fawry: "auth.subscriptions",
    },
    month: {
      
      stripe: "auth.subscriptions",
    },
    monthly_premium: {
      stripe: "auth.subscriptions",
            fawry: "auth.subscriptions",

    },
    year: {
      
      stripe: "auth.subscriptions",
            fawry: "auth.subscriptions",

    }
  },
  saudi: {
    weekly: {
      mobily: "https://mobily.nasna.tv/auth/mobily/subscribe",
      stc: "https://stc.nasna.tv/auth/subscribe",
            stripe: "auth.subscriptions",

    },
    month: {
      mobily: "https://mobily.nasna.tv/auth/mobily/subscribe",
      stc: "https://stc.nasna.tv/auth/subscribe",
      stripe: "auth.subscriptions",

    },
    year: {
      stripe: "auth.subscriptions",
    }
  },
  uae: {
    day: {
      etisalat: "https://ae.nasna.tv/subscribe",
      du: "https://du.nasna.tv/auth/subscribe",

    },
    weekly: {
      etisalat: "https://ae.nasna.tv/subscribe",
      du: "https://du.nasna.tv/auth/subscribe",
      
    },
    month: {
      etisalat: "https://ae.nasna.tv/subscribe",
            stripe: "auth.subscriptions",
      du: "https://du.nasna.tv/auth/subscribe",

    },
    year: {
      stripe: "auth.subscriptions",
    }
  },
  restOfWorld: {
    month: {
      
      stripe: "auth.subscriptions",
    },
    monthly_premium: {
       
      stripe: "auth.subscriptions",
    },
    year: {
      
      stripe: "auth.subscriptions",
    },

  },
};












export const stripeResponseCodes = {
  CREATE_PAYMENT_INTENT_FAILED: "فشل في إنشاء عملية الدفع",
  CREATE_PAYMENT_INTENT_SUCCEEDED: "تم إنشاء عملية الدفع بنجاح",
  active_sub: "لديك اشتراك نشط  ",
  PAYMENT_SUCCEEDED: "تم الدفع بنجاح",
  PAYMENT_FAILED: "فشل في عملية الدفع",
};























export const translatedCountries = {
  EG: "مصر",
  SA: "المملكة العربية السعودية",
  AE: "الإمارات العربية المتحدة",
  QA: "قطر",
  SD: "السودان",
  FR: "فرنسا",
  BE: "بلجيكا",
  DE: "ألمانيا",
  US: "الولايات المتحدة الأمريكية",
  IT: "إيطاليا",
  ES: "إسبانيا",
  IN: "الهند",
  PK: "باكستان",
  TR: "تركيا",
  CN: "الصين",
  JP: "اليابان",
  RU: "روسيا",
  BR: "البرازيل",
  AR: "الأرجنتين",
  MX: "المكسيك",
  ID: "إندونيسيا",
  NG: "نيجيريا",
  ZA: "جنوب أفريقيا",
  GB: "المملكة المتحدة",
  CA: "كندا",
  AU: "أستراليا",
  NZ: "نيوزيلندا",
  SE: "السويد",
  NO: "النرويج",
  DK: "الدنمارك",
  FI: "فنلندا",
  CH: "سويسرا",
  NL: "هولندا",
  AT: "النمسا",
  PL: "بولندا",
  GR: "اليونان",
  PT: "البرتغال",
  TH: "تايلاند",
  MY: "ماليزيا",
  SG: "سنغافورة",
  PH: "الفلبين",
  VN: "فيتنام",
  KR: "كوريا الجنوبية",
  LY: "ليبيا",
  MA: "المغرب",
  DZ: "الجزائر",
  TN: "تونس",
  OM: "عمان",
  KW: "الكويت",
  BH: "البحرين",
  JO: "الأردن",
  LB: "لبنان",
  SY: "سوريا",
  IQ: "العراق",
  YE: "اليمن",
  PS: "فلسطين",
  IL: "إسرائيل",
  CY: "قبرص",
  MT: "مالطا",
  IS: "أيسلندا",
  HU: "المجر",
  CZ: "التشيك",
  SK: "سلوفاكيا",
  UA: "أوكرانيا",
  BY: "بيلاروسيا",
  KZ: "كازاخستان",
  UZ: "أوزبكستان",
  AF: "أفغانستان",
  BD: "بنغلاديش",
  LK: "سريلانكا",
  NP: "نيبال",
  MM: "ميانمار",
  KE: "كينيا",
  UG: "أوغندا",
  ET: "إثيوبيا",
  GH: "غانا",
  CI: "ساحل العاج",
  SN: "السنغال",
  CL: "تشيلي",
  CO: "كولومبيا",
  VE: "فنزويلا",
  PE: "بيرو",
  CR: "كوستاريكا",
  PA: "بنما",
  UY: "أوروجواي",
  DO: "جمهورية الدومينيكان",
  HT: "هايتي",
  CU: "كوبا",
  JM: "جامايكا",
  TT: "ترينيداد وتوباغو",
  IR: "إيران",
  AZ: "أذربيجان",
  KG: "قرغيزستان",
  TJ: "طاجيكستان",
  MN: "منغوليا",
  KH: "كمبوديا",
  LA: "لاوس",
  MZ: "موزمبيق",
  ZM: "زامبيا",
  MG: "مدغشقر",
  BW: "بوتسوانا",
  NA: "ناميبيا",
}


export const paymentGatewaysOpto =  [
  "stripe", 
  "yallapay",
   "fawry-eg"
];